var map = {
	"./start-1.png": 3900,
	"./start-1@2x.png": 7660,
	"./start-2.png": 2631,
	"./start-2@2x.png": 4009,
	"./start-3.png": 8990,
	"./start-3@2x.png": 3702,
	"./start-4.png": 5729,
	"./start-4@2x.png": 9187,
	"./start-5.png": 3016,
	"./start-5@2x.png": 9200,
	"./start-6.png": 7507,
	"./start-6@2x.png": 7117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6638;